import Transformer from "./transformer";

/**
 * UI component for the trips cost calculation
 */
export default class TripsCost {

  /**
   * Constructor
   * @param tripsCostCalculator
   * @param $container
   * @param map
   * @param selectedSitesModel
   */
  constructor(tripsCostCalculator, $container, map, selectedSitesModel) {
    this._tripsCostCalculator = tripsCostCalculator;
    this._$container = $container;
    this._siteSelectionModel = selectedSitesModel;
    this._$infoEl = this._$container.find('#trips-cost-trip-info');
    this._$costValueEl = this._$container.find('#trips-cost-cost-value');

    this._isActivated = false;

    this._map = map;
    this._tripsLayerGroup = new ol.layer.Group();
    this._map.getLayers().push(this._tripsLayerGroup);

    // add event listener
    this._$container.find('.save-as-csv').click('click', (event) => this.handleDownloadCSV(event));
    this._$container.find('.cost-calculation-activation-switch label').click('click', (event) => this.handleActivationSwitch(event));

    this._tripColours = [
      '#4286f4',
      '#f45341',
      '#f4c141',
      '#f4ee41',
      '#94f441',
      '#41f4ca',
      '#9441f4',
      '#f441b8'
    ];
  }

  /**
   * Update the UI
   */
  update() {
    if (!this._isActivated) {
      return;
    }

    if (Object.keys(this._siteSelectionModel.getData()).length > 0) {
      let trips = this._tripsCostCalculator.calculate(
        Transformer.transformSelectedFeatures(this._siteSelectionModel.getData())
      );

      this._updateInfoPanel(trips);
      this._updateMap(trips);
    } else {
      this._clearMap();
      this._clearInfoPanel();
    }
  }

  /**
   * Download the trips as a CSV file
   * @param event
   */
  handleDownloadCSV(event) {
    event.preventDefault();

		let wktFormat = new ol.format.WKT();

		let csvString = 'Trip-ID,Costs,Geom\r\n';
    this._tripsLayerGroup.getLayers().forEach((layer) => {
			layer.getSource().getFeatures().forEach((feature) => {
				if (feature.getGeometry() instanceof ol.geom.MultiLineString) {
					csvString += feature.get('tripId') + ',' + feature.get('costs') + ',' +
						encodeURIComponent(wktFormat.writeFeature(feature, {featureProjection: 'EPSG:3857', dataProjection:	'EPSG:4326'})) + '\r\n'
				}
			});
		});

		if (csvString !== '') {
			let downloadLink = document.createElement('a');
			downloadLink.setAttribute('href', 'data:text/csv;charset=utf-8,' + csvString);
			downloadLink.setAttribute('download', 'reefTrips.csv');
			downloadLink.style.display = 'none';

			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		} else {
			alert('Nothing to export');
		}
	};

  /**
   * Update or remove trips on click on the switch
   * @param event
   */
  handleActivationSwitch(event) {
    if ($(event.target).find('#cost-calculation-activated').length === 1) {
      this._isActivated = true;
      this.update();
    } else {
      this._isActivated = false;
      this._clearMap();
      this._clearInfoPanel();
    }
  }

  /**
   * Update the info panel
   * @param trips
   * @private
   */
  _updateInfoPanel(trips) {
    const tripColours = this._tripColours.slice();

    this._$costValueEl.html(trips.reduce((totalCosts, trip) => totalCosts + trip.days.length, 0) + ' days');

    let infoHtml = '<ul class="list-group">';
    trips.forEach((trip) => {
      infoHtml += '<li class="list-group-item" style="background: ' + tripColours.shift() + '">Trip: ' + trip.id + '</li>';
      infoHtml += '<li class="list-group-item"><ul class="list-group">';

      trip.days.forEach((day) => {
        if (day.type === 'steaming') {
          infoHtml += '<li class="list-group-item">Steaming: ' + day.destination.name + '</li>'
        } else {
          infoHtml += '<li class="list-group-item">Monitoring: ' + day.destination.name + '</li>'
        }
      });

      infoHtml += '</ul></li>';
    });
    infoHtml += '</ul>';
    this._$infoEl.html(
      '<p>Trips: ' + infoHtml + '</p>'
    );
  }

  /**
   * Update the OL map
   * @param trips
   * @private
   */
  _updateMap(trips) {
    this._clearMap();
    const tripColours = this._tripColours.slice();

    trips.forEach((trip) => {
      let source = new ol.source.Vector({wrapX: false});
      let track = new ol.geom.MultiLineString();
      let lastLocation = trip.startLocation;

      trip.days.forEach((day) => {
        if (day.destination) {
          track.appendLineString(new ol.geom.LineString(
            [
              // ol.proj.transform([lastLocation.longitude, lastLocation.latitude], 'EPSG:4326', 'EPSG:3857'),
              // ol.proj.transform([day.destination.longitude, day.destination.latitude], 'EPSG:4326', 'EPSG:3857'),
              [lastLocation.longitude, lastLocation.latitude],
              [day.destination.longitude, day.destination.latitude]
            ]
          ));
          lastLocation = day.destination;
        }
      });

      let feature = new ol.Feature({
        name: "Trip " + trip.id,
        geometry: track
      });
      feature.set('tripId', trip.id);
      feature.set('costs', trip.days.length);
      source.addFeature(feature);

      let vector = new ol.layer.Vector({
        source: source,
        style: new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: tripColours.shift(),
            width: 1
          })
        })
      });

      this._tripsLayerGroup.getLayers().push(vector);
    });
  }

  /**
   * Remove the trips from the map
   * @private
   */
  _clearMap() {
    // remove trips
    this._tripsLayerGroup.getLayers().clear();
  }

  /**
   * Clear the info panel
   * @private
   */
  _clearInfoPanel() {
    this._$costValueEl.html('');
    this._$infoEl.html('<p>Trips:</p>');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/trips-costs/component.js